<template>
  <div class="content">
    <div class="head">
      <div class="container">
        <div class="row">
          <img class="logoImg" src="../assets/img/logo.png" />
        </div>
      </div>
    </div>
    <div class="login">
      <div class="container">
        <div class="row">
          <h1>自分の番号でログインしてね</h1>
          <div
            @click="login(val.id, val.stName)"
            v-for="val in Users"
            :key="val.id"
            class="two columns button"
          >
            {{ val.stName }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "login",
  data() {
    return {
      Users: [],
    };
  },
  beforeCreate() {
    if (!this.$store.state.loggedIn) {
      this.$router.push({ name: "selectClass" });
    }
  },
  created: function () {
    let _this = this;
    axios
      .get(
        _this.$store.state.APIbase + "api/users/" + this.$route.params.classNum
      )
      .then((res) => {
        _this.Users = res.data;
        _this.$store.state.classNum = _this.$route.params.classNum;
      });
  },
  methods: {
    login: function (e, stName) {
      var self = this;
      self.$store.state.id = e;
      self.$store.state.stName = stName;
      var param = { classNum: self.$route.params.classNum, stName: stName };
      axios
        .post(
          self.$store.state.APIbase + "api/login/" + self.$store.state.id,
          param
        )
        .then(() => {
          self.$router.push({ name: "home" });
        });
    },
  },
};
</script>

<style scoped>
.head {
  width: 100%;
  height: 150px;
  min-height: 30px;
  background: #4690cf;
  text-align: center;
}
.logoImg {
  width: 200px;
  margin-top: 0;
}
.login {
  padding-top: 20px;
  background: rgb(238, 247, 255);
  box-shadow: 0px -4px 2px rgba(0, 0, 0, 0.5);
  text-align: center;
}
.button {
  padding-top: 10px;
  padding-bottom: 40px;
  margin-left: 3%;
  transition: all 0.3s;
}
@media (min-width: 700px) {
  .button {
    margin-left: 0;
    margin-right: 3%;
  }
}
.button:hover {
  transform: scale(1.1);
}
.button:active {
  transform: scale(0.9);
}
</style>
